import React from 'react';
import { HStack } from '@chakra-ui/react';
import { NotchedButton, ChainSelector } from '@components';

interface ConnectWalletButtonProps {
  showButton?: boolean;
  onConnect: () => void;
}

export const ConnectWalletButton: React.FC<ConnectWalletButtonProps> = ({
  showButton,
  onConnect,
}) => (
  <HStack spacing={3} align="center">
    <ChainSelector />
    <NotchedButton
      transparent={showButton}
      bgColor="primary"
      color="white"
      p={'.5rem 1rem'}
      borderRadius="4px!important"
      onClick={onConnect}
      _hover={{ background: showButton ? 'transparent' : 'E2E8F0' }}
    >
      Kết nối ví
    </NotchedButton>
  </HStack>
);
